package app.bloomey.web.modules.library

import app.bloomey.web.core.data.UiState
import com.copperleaf.ballast.InputHandler
import com.copperleaf.ballast.InputHandlerScope
import kotlinx.coroutines.flow.collectLatest

class LibraryInputHandler : InputHandler<
        LibraryContract.Inputs,
        LibraryContract.Events,
        LibraryContract.State> {

    private val repository = LibraryRepository()
    override suspend fun InputHandlerScope<
            LibraryContract.Inputs,
            LibraryContract.Events,
            LibraryContract.State>.handleInput(
        input: LibraryContract.Inputs,
    ): Unit = when (input) {
        is LibraryContract.Inputs.GetLibraries -> {
            repository.getLibraries(page = input.page, size = input.size, input.query).collectLatest { state ->
                updateState {
                    it.copy(libraries = state, page = input.page)
                }
            }
        }

        is LibraryContract.Inputs.GetLibraryVideos -> {
            repository.getCategoryVideos(id = input.libraryId, page = input.page, size = input.size)
                .collectLatest { state ->
                    updateState {
                        it.copy(detailVideos = state, detailsPage = input.page)
                    }
                }
        }

        is LibraryContract.Inputs.DeleteLibrary -> {
            repository.deleteLibrary(id = input.libraryId).collectLatest { state ->
                updateState {
                    it.copy(deleteLibrary = state)
                }
            }
        }

        is LibraryContract.Inputs.UpdateLibrary -> {
            repository.updateLibrary(id = input.libraryId, input.request).collectLatest { state ->
                updateState {
                    it.copy(updateLibrary = state)
                }
            }
        }

        is LibraryContract.Inputs.ResetState -> {
            when (input.property) {
                LibraryContract.State::updateLibrary.name -> {
                    updateState { it.copy(updateLibrary = UiState.Initial) }
                }

                else -> {}
            }
        }
    }
}
